import config from 'src/config';

export const loadUrlParamsFromObject = (filterUrlParams?: Object, withValuesFalsy?: boolean) => {
  const params = new URLSearchParams();
  if (typeof filterUrlParams === 'object' && filterUrlParams !== null) {
    Object.keys(filterUrlParams).forEach((key) => {
      // pass this value when the endpoint doesn't accept empty params
      if (withValuesFalsy) {
        params.append(key?.toString(), filterUrlParams[key]?.toString());
        return;
      }
      if (key && filterUrlParams[key]) {
        params.append(key.toString(), filterUrlParams[key].toString());
      }
    });
  }
  return params.toString();
};

export const getCuitList = (cuits: string[]) => {
  return cuits?.length > 0 ? cuits?.join() : [];
};

export const API_STORES_BO_URL = config.api.storesBffUrl || 'http://localhost:3000';
export const API_REWARDS_BO_URL = config.api.rewardsHandlerUrl || 'http://localhost:3000';
export const AUTH0_REDIRECT_URI = config.api.auth0RedirectUri || 'http://localhost:3000';
export const API_PROMOTIONS_BO_URL = config.api.promoBffUrl || 'http://localhost:3000';

export const USERS_PATH = '/users';
export const TRANSACTION_PATH = '/transactions';
export const EXPORT_TRANSACTION_PATH = '/transactions/export';
export const TRANSACTION_PATH_V2 = '/v2/transactions';
/**
 * KPIs del listado. El BFF los expone bajo /v2/transactions/kpis;
 * el /transactions/summary que asumia el contrato original nunca existio.
 */
export const SUMMARY_TRANSACTION_PATH = '/v2/transactions/kpis';
export const METADATA_TRANSACTION_PATH = '/transactions/metadata';
export const SEARCH_TRANSACTION_PATH = '/transactions/search';
/** Ventana de tolerancia de la búsqueda exacta (H3); la aplica el BFF sobre `datetime`. */
export const SEARCH_TOLERANCE_MINUTES = 10;
export const STORE_PATH = '/stores';
export const PROMOTIONS_PATH = '/promotions';
export const CALENDAR_PATH = '/calendar';
export const BANKS_PATH = '/banks';
export const COMPANY_POSITIONS_PATH = '/company_positions';
export const LIQUIDATION_SUMMARY_PATH = '/liquidation_summary';
export const METRICS_PATH = 'metrics';
export const SOURCE_BO = 'bo_portal';

export const EXPORT_TYPE_CSV = 'csv';
